import React from 'react';

const CommentLikedIcon = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.9837 0C11.2688 0 9.80345 1.24358 8.99836 2.10093C8.19327 1.24358 6.73118 0 5.01709 0C2.06264 0 0 2.0951 0 5.09416C0 8.39871 2.56173 10.5346 5.04 12.6006C6.21 13.5769 7.42091 14.5858 8.34954 15.7045C8.50582 15.8918 8.73491 16 8.97545 16H9.02291C9.26427 16 9.49255 15.891 9.648 15.7045C10.5783 14.5858 11.7884 13.5761 12.9592 12.6006C15.4366 10.5354 18 8.39954 18 5.09416C18 2.0951 15.9374 0 12.9837 0Z" fill="#1CA5E0" />
  </svg>
);

export default CommentLikedIcon;
